import React from "react";
import { MapPin, Star } from "lucide-react";
import { Link } from "react-router-dom";

const ListingCard = ({ listing }) => {

  const href = listing.url || listing.productUrl || `/things-to-do/${listing.slug || listing.id}`;
  const image = listing.productImageUrl || listing.media?.find((item) => item.type === "image")?.url;
  const hasRating = Number(listing.rating) > 0;
  const price = listing.displayFromPrice
    ? `From ${listing.currency || "USD"} ${listing.displayFromPrice}`
    : "View current price";

  return (
    <div className="things-listing-card card h-100 border-0">
      <Link to={href} className="things-listing-image-wrap text-decoration-none">
        {image ? <img src={image} className="card-img-top" alt="" /> : <div className="things-listing-image-placeholder" />}
        <span className="things-location-chip"><MapPin aria-hidden="true" /> {listing.city || listing.country || "Destination"}</span>
        <span className="things-price-chip">{price}</span>
      </Link>

      <div className="card-body d-flex flex-column">
        <h5 className="things-listing-title mb-2">{listing.title}</h5>
        <p className="things-listing-desc mb-0">{listing.description}</p>
      </div>

      <div className="things-listing-footer">
        {hasRating ? (
          <span className="things-listing-rating"><Star aria-hidden="true" /> {listing.rating} {Number(listing.totalReviews) > 0 && <small>({listing.totalReviews} reviews)</small>}</span>
        ) : <span className="things-listing-rating things-listing-rating--new">New</span>}
        <Link to={href}>View details</Link>
      </div>
    </div>
  );
};

export default ListingCard;
